export default "__VITE_ASSET__ce0a9af0__"